export const siteInfo = {
  name: "曝光档案局",
  shortName: "档案局",
  slogan: "把翻车现场，整理成一份档案",
  tagline: "渣男曝光 · 翻车现场合集",
  description:
    "收录被拆穿瞬间、被抓现行、打脸现场与社死瞬间，配合情感避雷指南，让你吃瓜吃得明白，也走得利落。",
  email: "hey@expose-scene.example.com",
  weeklyUpdate: "每周三、周日更新档案",
};

export const navLinks = [
  { id: "featured", label: "热门现场", icon: "ri-fire-line" },
  { id: "latest", label: "最新收录", icon: "ri-history-line" },
  { id: "topics", label: "专题合辑", icon: "ri-bookmark-3-line" },
  { id: "guide", label: "避雷指南", icon: "ri-shield-star-line" },
  { id: "faq", label: "常见问题", icon: "ri-question-line" },
  { id: "about", label: "关于我们", icon: "ri-chat-quote-line" },
];

export const siteStats = [
  { id: "stat-01", value: "3,842", label: "已收录现场", unit: "篇", icon: "ri-archive-2-line" },
  { id: "stat-02", value: "126", label: "本周新增", unit: "篇", icon: "ri-add-circle-line" },
  { id: "stat-03", value: "58", label: "专题合辑", unit: "辑", icon: "ri-bookmark-3-line" },
  { id: "stat-04", value: "97.4%", label: "读者直呼太爽", unit: "", icon: "ri-emotion-happy-line" },
];

export const testimonials = [
  {
    id: "say-01",
    name: "阿枣不加糖",
    role: "读者 · 关注 2 年",
    content:
      "别的号只会甩一句「快跑」，这里会告诉你从哪一步开始跑。避雷指南那篇自查清单，我照着对了一遍，直接少走半年弯路。",
    rating: 5,
  },
  {
    id: "say-02",
    name: "深夜两点半",
    role: "投稿者",
    content:
      "投稿之后是我第一次把这些事情完整地说出来。编辑帮我把所有能识别身份的信息都打了码，成稿那天我看完，心里的那块石头终于落地了。",
    rating: 5,
  },
  {
    id: "say-03",
    name: "木木不困",
    role: "读者 · 收藏 47 篇",
    content:
      "最上头的还是翻车合集，一条时间线拉下来逻辑清清楚楚。看着看着就笑了，笑着笑着就清醒了。",
    rating: 5,
  },
  {
    id: "say-04",
    name: "海盐柠檬",
    role: "读者 · 关注 1 年",
    content:
      "排版像在看一本旧档案，读起来一点都不聒噪。分类分得很细，想找哪种现场基本一眼就能定位。",
    rating: 5,
  },
];

export const principles = [
  {
    id: "principle-01",
    title: "只留情节，不留身份",
    desc: "所有案例都会隐去姓名、头像、城市与可定位细节，昵称统一改写，只保留冲突本身。",
    icon: "ri-shield-user-line",
  },
  {
    id: "principle-02",
    title: "先守法，再吃瓜",
    desc: "涉及隐私、名誉与证据的部分，我们会在投稿须知里反复提醒边界，避免把避雷做成侵权。",
    icon: "ri-scales-3-line",
  },
  {
    id: "principle-03",
    title: "情绪之后给方法",
    desc: "爽文看完总要有出口。每一辑现场都会配一篇可执行的避雷或复原指南，把情绪变成判断力。",
    icon: "ri-compass-3-line",
  },
];

export const faqs = [
  {
    id: "faq-01",
    q: "网站里的翻车现场都是真实发生的吗？",
    a: "站内所有案例均为读者投稿后重新改编的虚构情节合集，人物、昵称与细节都做过模糊处理，只保留情节冲突，不对应任何真实个人。阅读时请把它当成一本「情感案例合集」，而不是对号入座的名单。",
  },
  {
    id: "faq-02",
    q: "我可以投稿自己的翻车现场吗？",
    a: "可以。在页面底部的爆料投稿区填写情节梗概、关键节点和你想吐槽的重点即可。投稿时请务必打码头像、昵称、手机号与可定位信息，我们会隐去一切可识别内容后再整理成档。",
  },
  {
    id: "faq-03",
    q: "投稿之后多久会出现在网站上？",
    a: "一般 3 到 7 个工作日内完成整理与情节核实。若情节具有代表性，会优先收录进当周的专题合辑；如果信息不足，我们会通过你留下的联系方式补充确认。",
  },
  {
    id: "faq-04",
    q: "曝光别人的聊天记录会不会有风险？",
    a: "会，而且风险不低。我们建议先保存证据并咨询专业法律意见，投稿时一定要对头像、昵称、手机号、公司名等信息打码，避免从「避雷」变成「侵权」。保护好自己的前提下，再谈曝光。",
  },
  {
    id: "faq-05",
    q: "如何判断自己是不是正在经历一段高风险关系？",
    a: "重点看三点：承诺与行为是否长期不一致、是否刻意切断你与外界的联系、是否反复用情绪指责让你自我怀疑。只要有两项长期成立，就值得停下来认真评估。站内避雷指南里有更完整的自查清单。",
  },
];

export const footerColumns = [
  {
    id: "col-01",
    title: "内容栏目",
    links: [
      { label: "热门现场", href: "#featured" },
      { label: "最新收录", href: "#latest" },
      { label: "专题合辑", href: "#topics" },
      { label: "避雷指南", href: "#guide" },
    ],
  },
  {
    id: "col-02",
    title: "关于本站",
    links: [
      { label: "关于我们", href: "#about" },
      { label: "内容原则", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "爆料投稿", href: "#contact" },
    ],
  },
  {
    id: "col-03",
    title: "投稿须知",
    links: [
      { label: "隐去可识别信息", href: "#faq" },
      { label: "保存原始证据", href: "#guide" },
      { label: "避免侵犯隐私", href: "#faq" },
      { label: "联系编辑部", href: "#contact" },
    ],
  },
];

export const marqueeWords = [
  "被拆穿瞬间",
  "被抓现行",
  "打脸现场",
  "社死瞬间",
  "翻车合集",
  "深夜加班话术",
  "定位不符",
  "统一台词",
];